/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isEmpty, get } from 'lodash';
import { Stack, Text, Box } from '@towersystems/towersystems-design-system';
import Skeleton from 'react-loading-skeleton';

/**
 * Internal dependencies
 */
import { requestPaymentMethods, removePaymentMethod } from 'state/payment-methods/actions';
import {
    getAllPaymentMethods,
    requestingPaymentMethods,
    errorRequestingPaymentMethods,
} from 'state/payment-methods/selectors';
import Button from 'components/button';
import classNames from 'classnames';
import toDescriptionString from 'components/payment-method-status/to-description-string';
import ErrorContent from 'modules/me/error-content';
import Card from 'components/card';
import { createOpenModalAction } from 'state/ui/actions';
import { successNotice } from 'state/notices/actions';
import Item from './item';
import { getPrimaryPaymentSourceId } from 'state/current-user/selectors';
import Icon from 'components/icon';
import cscom from 'lib/customer-site-api';
import FlashMessage from 'components/flash-message';

// need to initialize this somewhere, then remove this line
import cb from 'lib/chargebee';

/**
 * Style dependencies
 */
import './styles.scss';

const PaymentMethodsList = ({ primaryPaymentSourceId, ...props }) => {
    const [requesting, setRequesting] = useState(false);

    useEffect(() => {
        loadPaymentMethods();
    }, []);

    const loadPaymentMethods = async () => {
        try {
            setRequesting(true);
            await props.requestPaymentMethods();
        } catch (error) {}
        setRequesting(false);
    };

    const paymentMethods = props.paymentMethods;

    const addNewPaymentMethod = () => {
        props.openPaymentMethodModal();
    };

    const openChargebeeCheckout = () => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().hostedPaymentMethods(),
            error: (e) => console.log(e),
            // close: () => { window.location.reload(); },
            success: () => { },
        });
    };

    if (isEmpty(paymentMethods) && props.requesting) {
        return (
            <Stack space='large'>
                <Skeleton width={500} />
                <Skeleton width={500} />
                <Skeleton width={500} />
            </Stack>
        );
    }

    return (
        <Box>
            {(paymentMethods) &&(paymentMethods.length <=0) && (
                <Box><FlashMessage warning="true" body="Please click + Add payment method button below to setup your payment" /></Box>
            )}   
            <Stack>
                {paymentMethods.map((paymentMethod) => {
                    return paymentMethod.type == 'direct_debit' ? (
                        <Item
                            key={paymentMethod.id}
                            id={paymentMethod.id}
                            type={paymentMethod.type}
                            title={`ending *${paymentMethod.bank_account.last4}`}
                            description={toDescriptionString(paymentMethod.status)}
                            removeItem={props.removePaymentMethod}
                            afterSuccessRemoveItem={() => props.successNotice('Payment source removed')}
                            primary={primaryPaymentSourceId == paymentMethod.id}
                        />
                    ) : (
                        <Item
                            key={paymentMethod.id}
                            id={paymentMethod.id}
                            type={paymentMethod.card.brand}
                            title={`ending ${paymentMethod.card.last4}`}
                            description={toDescriptionString(paymentMethod.status)}
                            removeItem={props.removePaymentMethod}
                            afterSuccessRemoveItem={() => props.successNotice('Payment source removed')}
                            beforeActions={
                                <Box display='flex' alignItems='center' paddingRight='large'>{`Expires ${get(
                                    paymentMethod,
                                    'card.expiry_month',
                                )}/${get(paymentMethod, 'card.expiry_year')}`}</Box>
                            }
                            primary={primaryPaymentSourceId == paymentMethod.id}
                        />
                    );
                })}
            </Stack>
            <Box marginTop='large'>
                <Button primary onClick={openChargebeeCheckout}>
                    <Box display='flex' alignItems='center'>
                        <Box paddingRight='large' display='flex' alignItems='center'>
                            <Icon type='fi' name='FiPlus' />
                        </Box>
                        <Text>Add payment method</Text>
                    </Box>
                </Button>
            </Box>
        </Box>
    );
};

export default connect(
    (state) => ({
        paymentMethods: getAllPaymentMethods(state),
        requesting: requestingPaymentMethods(state),
        error: errorRequestingPaymentMethods(state),
        primaryPaymentSourceId: getPrimaryPaymentSourceId(state),
    }),
    {
        requestPaymentMethods,
        removePaymentMethod,
        openPaymentMethodModal: createOpenModalAction('AddPaymentMethodModal'),
        successNotice,
        
    },
)(PaymentMethodsList);
